import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UnavailableRequestsReportsComponent } from './unavailable-requests-reports.component';

const routes: Routes = [
  {
    path: '',
    component: UnavailableRequestsReportsComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UnavailableRequestsReportsRoutingModule { }
